export default e => ({
  // 箭头函数return 对象 简写要加()
  apiEnv: '', // 接口环境
  locales: ['en', 'zh'], // 当前所有语言环境
  locale: 'en', // 当前语言环境
  titlePreWords: 'Kilimall Online Shopping In Bangladesh - ',
  navHeight: '.76rem',
  accessToken: '',
  userName: '',
  isLogin: '',
  // roomList: [],
  // messageCount: 0,
  regionList: {}, // 区域信息
  storeInfo: {}, // 当前店铺信息
  openRegionStations: [], // 开放的国家信息
  localText: 'EN',

  messageNotReadTotal: 0,
  menuAllData: [],
  storeRegionId: {}, // nuxt上下文对象种的 app
  registerStoreInfo: null // 注册店铺信息--step4的信息暂存使用(返回上一步回到step4时反显已填写店铺信息可用)
})
